var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	var cfg = actInfo.overallRanking;
	var time = UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime*1000,cfg.endTime*1000,UpAct.lang.lang)

__p+='\n<div class="app-page">\n	<div class="header">\n		<div class="girl"></div>\n		<div class="act-time">'+
((__t=(lang.template("活动时间")))==null?'':__t)+
'</div>\n	</div>\n	\n	<div class="page-body" >\n		<div class="intro intro-hidden">\n			\n			<div class="intro-cont">\n				'+
((__t=(lang.template('活动简介内容')))==null?'':__t)+
'\n			</div>\n			<div class="intro-toggle"><span></span></div>\n		</div>\n		<div class="panel gift-block">\n			\n			<div class="panel-content">\n				<div class="gifts">\n				';

					_.each(actInfo.gift,function(item,index){
				
__p+='\n					<div class="gift gift'+
((__t=(index+1))==null?'':__t)+
'">\n						<p class="giftpic"><img src="'+
((__t=(item.image))==null?'':__t)+
'"/></p>\n						<span class="gift-name">'+
((__t=(lang.template('gift'+(index+1))))==null?'':__t)+
'</span>\n					</div>\n				';

					});
				
__p+='\n				</div>\n			</div>\n		</div>\n		<div class="rule" node-id="rule-btn">\n			<h2 class="title">'+
((__t=(lang.template('活动规则')))==null?'':__t)+
'</h2>\n		</div>\n	</div>\n	<div class="page-content" id="page-content"></div>	\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/template/page.tmpl
// module id = 75
// module chunks = 0